import { device } from '../../../utils/styled-component-mixins';
import useMediaQuery from '../../custom-hooks/useMediaQuery';
import { useLocationContext } from './LocationContext';

const Hero = () => {
  const {
    heroTitle,
    heroSubtitle,
    heroDescription,
    heroBackgroundImage,
    heroMobileBackgroundImage,
    heroCtaButtonText,
    heroCtaButtonUrl,
    heroCtaButtonScrollToComponent
  } = useLocationContext();

  const isDesktop = useMediaQuery(device.desktop, null);

  const heroSubtitleHTML = `<h2>${heroSubtitle}</h2>`;

  const myData = isDesktop ? heroSubtitleHTML + heroDescription : heroDescription;

  const cleanedMyData = myData.replace(/(href|src)=["']~\//g, '$1="/');

  return (
    <div className="location-hero">
      {isDesktop != null && (
        <img
          className="background-image"
          src={isDesktop ? heroBackgroundImage : heroMobileBackgroundImage}
          alt=""
        />
      )}
      <div className="title-only">
        <h1 className="hero-title">{heroTitle}</h1>
        {!isDesktop && (
          <h2 className="hero-subtitle" dangerouslySetInnerHTML={{ __html: heroSubtitle }} />
        )}
      </div>
      <div className="hero-description" dangerouslySetInnerHTML={{ __html: cleanedMyData }} />
      <div className="button-only">
        {heroCtaButtonText && heroCtaButtonUrl && (
          <a className="hero-button btn btn-primary" href={heroCtaButtonUrl}>
            {heroCtaButtonText}
          </a>
        )}
        {heroCtaButtonText && heroCtaButtonScrollToComponent && (
          <a
            className="hero-button btn btn-primary"
            onClick={() =>
              document.getElementsByClassName(heroCtaButtonScrollToComponent)[0].scrollIntoView()
            }
          >
            {heroCtaButtonText}
          </a>
        )}
      </div>
    </div>
  );
};

export default Hero;
